// PAGINATION CONSTANTS

export const DOCUMENTS_PAGE_SIZE = 20;
export const DOCUMENTS_DEFAULT_OFFSET = 0;

// BREAKPOINT CONSTANTS

export const MOBILE_BREAKPOINT = "(max-width:890px)";
export const DRAWER_MOBILE_SIZE = "100vw";
export const DRAWER_DESKTOP_SIZE = "890px";

// TOAST MESSAGES

export const DOWNLOAD_SUCCESS_MESSAGE = (fileName: string) =>
  `Attachment ${fileName} was successfully downloaded`;

export const DOWNLOAD_ERROR_MESSAGE = (fileName: string) =>
  `Failed to download attachment ${fileName}`;

const PREVIEW_UNAVAILABLE_MESSAGE = "Preview unavailable";
const PREVIEW_DOWNLOAD_PROMPT =
  "Please download the document to view it.";
const PREVIEW_UNAVAILABLE_AUDIO_MESSAGE = "Preview unavailable";
const PREVIEW_DOWNLOAD_AUDIO_PROMPT =
  "Please download the audio to listen to it.";

// UI STRINGS

export const PAGE_TITLE = "Documents";
export const NO_DOCUMENTS_TITLE = "No documents found";
export const NO_DOCUMENTS_DESCRIPTION =
  "It's a blank slate here. Check back later for new documents to download or preview.";

export const TABLE_COLUMN_NAMES = {
  NAME: "Name",
  CREATED_DATE: "Created Date",
};

export const MENU_ITEMS = {
  PREVIEW: "Preview",
  DOWNLOAD: "Download",
  DOWNLOADING: "Downloading…",
};

export const BUTTON_TEXT = {
  DOWNLOAD: "Download",
  DOWNLOADING: "Downloading…",
  PREVIOUS: "Previous",
  NEXT: "Next",
};

// TABLE CONFIGURATION

export const TABLE_CONFIG = {
  NAME_MAX_WIDTH: "350px",
  DATE_MAX_WIDTH: "200px",
  // Documents renders inside the zoomed portal shell. Raw viewport units are
  // scaled a second time there, which shortens the table on narrower desktop
  // screens and leaves the paginator floating halfway up the page.
  FIXED_HEADER_SCROLL_HEIGHT: "calc(var(--shell-vh) - 260px)",
};

const MOBILE_TABLE_CONFIG = {
  NAME_WIDTH: "60%",
  DATE_WIDTH: "35%",
  ACTION_WIDTH: "5%",
  HEADER_NAME_WIDTH: "59%",
  HEADER_DATE_WIDTH: "34.5%",
  HEADER_ACTION_WIDTH: "5%",
  ROW_HEIGHT: "80%",
};

export const MOBILE_MENU_OFFSET = "-left-[115px]";
const DESKTOP_MENU_OFFSET = "-left-[130px]";

// SIZING CONSTANTS

const LOADING_SPINNER_SIZE = {
  SMALL: 5,
  MEDIUM: 16,
};

export const EMPTY_STATE_ICON_SIZE = {
  MOBILE: 80,
  DESKTOP: undefined,
};

// CSS CLASSES

export const SPINNER_CLASS =
  "inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]";

const SPINNER_CLASS_LARGE =
  "inline-block h-16 w-16 animate-spin rounded-full border-[5px] border-solid border-blue border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]";
